class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const button = this.querySelector('[id^="Deferred-Poster-"]');
    if (!button) return;

    button.addEventListener('click', () => {
      const template = this.querySelector('template');
      if (!template) return;

      const content = template.content.firstElementChild.cloneNode(true);
      this.appendChild(content);
      this.classList.add('loaded');
    });
  }
}

customElements.define('deferred-media', DeferredMedia);
